//import noise from "../contents/dev/noise.png";
import React from "react";
import Group1 from "../contents/dev/Group1.png";
import Group2 from "../contents/dev/Group2.png";
import Group3 from "../contents/dev/Group3.png";
import Group11 from "../contents/dev/Group11.png";
import Form from "../contents/dev/form_news.png"


export function LinkedIn() {
    // https://www.linkedin.com/feed/update/urn:li:activity:7343888250110930945
    // https://www.linkedin.com/embed/feed/update/urn:li:share:7333860289320247297?collapsed=1

    const posts = [
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7337725546920841216?collapsed=1',
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7335030970389086209?collapsed=1',
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7329910318845849600?collapsed=1',
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7331696434007699456?collapsed=1',
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7337725546920841216?collapsed=1',
        'https://www.linkedin.com/embed/feed/update/urn:li:share:7337725546920841216?collapsed=1'
    ]

    return (
        <div className="flex-grow flex flex-col bg-black h-full w-full relative">
            <div className="">
                <img className="absolute left-0 top-[800px]" src={Group3} alt=''/>
                <img className="absolute right-0" src={Group1} alt=''/>
                <img className="absolute left-0 top-[450px] w-full" src={Group11} alt=''/>
                <img className="absolute right-0 bottom-0" src={Group2} alt=''/>
                <img className="absolute left-0 bottom-96 w-full" src={Group11} alt=''/>
            </div>
            {/*<div className="absolute top-0 left-0 w-full h-full">*/}
            {/*    */}
            {/*</div>*/}
            <div className="flex flex-wrap justify-center gap-32 py-48 content relative">


                {posts.map((post, index) => (
                    <div key={index} className={index % 2 === 1 ? "relative mt-48" : "relative"}>
                        <iframe className="absolute right-8 top-8 card-link mb-4" src={post}
                                height="500" width="500" frameBorder="0" allowFullScreen=""
                                title="Embedded post"></iframe>
                        <div
                            className="absolute -top-10 left-60 p-2 flex items-center justify-center bg-gray-1 h-24 w-24 rounded-full border-2 border-amber-400">
                            <svg width="52" height="49" viewBox="0 0 52 49" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1144_2494)">
                                    <path
                                        d="M37.5138 12.376H50.1329V40.5702C50.1329 44.1985 47.2133 47.1334 43.6169 47.1334C40.0147 47.1334 37.1009 44.1927 37.1009 40.5702V1.8667H1.85938V41.6217C1.85938 44.6665 4.30861 47.1392 7.33718 47.1392H43.6226"
                                        stroke="#FACC15" strokeWidth="3" strokeLinejoin="round"/>
                                    <path d="M7.35156 9.18115H31.3277" stroke="#FACC15" strokeWidth="3"
                                          strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M7.35156 15.6113H31.3277" stroke="#FACC15" strokeWidth="3"
                                          strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M7.35156 24.5029H13.6037" stroke="#FACC15" strokeWidth="3"
                                          strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M7.35156 30.9912H13.6037" stroke="#FACC15" strokeWidth="3"
                                          strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M7.35156 39.9868H31.3277" stroke="#FACC15" strokeWidth="3"
                                          strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M30.9279 21.9087H19.1406V33.7815H30.9279V21.9087Z" stroke="#FACC15"
                                          strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1144_2494">
                                        <rect width="52" height="49" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <img src={Form} alt=''/>
                    </div>
                ))}
            </div>
        </div>

    );
}